export const RESET = 'SEQUENTIAL_MODALS/RESET';
export const DONE_REQUEST = 'SEQUENTIAL_MODALS/DONE_REQUEST';
export const DONE_SUCCESS = 'SEQUENTIAL_MODALS/DONE_SUCCESS';
export const SET_STATUS = 'SEQUENTIAL_MODALS/SET_STATUS';
export const DECREASE_MODAL_COUNT = 'SEQUENTIAL_MODAL/DECREASE_MODAL_COUNT';
export const SET_MODAL_COUNT_TO_ZERO = 'SEQUENTIAL_MODAL/SET_MODAL_COUNT_TO_ZERO';
export const SET_MODAL_COUNT = 'SEQUENTIAL_MODAL/SET_MODAL_COUNT';
